// One row of the review conversation, GitHub timeline style: initials
// avatar on the left, a bordered card on the right with a caret pointing
// back at the avatar. Cards (submission, comments, the composer) supply
// their own header/body as children.

import { Avatar } from '@/components/ui/Avatar'

export default function TimelineItem({ name, avatarUrl, children }: {
  name: string
  avatarUrl?: string | null
  children: React.ReactNode
}) {
  return (
    <div className="flex min-w-0 items-start gap-3">
      <Avatar aria-hidden size="lg" tone="primary" name={name} avatarUrl={avatarUrl} />
      <div
        style={{ background: 'var(--background)', borderColor: 'var(--border)' }}
        className="relative min-w-0 flex-1 rounded-lg border"
      >
        {/* Caret: border-color triangle underneath, background triangle 1px
            inset on top. */}
        <span
          aria-hidden
          className="absolute top-3 h-0 w-0"
          style={{ left: -8, borderTop: '8px solid transparent', borderBottom: '8px solid transparent', borderRight: '8px solid var(--border)' }}
        />
        <span
          aria-hidden
          className="absolute top-3 h-0 w-0"
          style={{ left: -7, borderTop: '8px solid transparent', borderBottom: '8px solid transparent', borderRight: '8px solid var(--background)' }}
        />
        {children}
      </div>
    </div>
  )
}
